<div class="row utils-bar comment-events-utils-bar">
  <div class="row table-filter">
    <form (submit)="updateSearchFilter()" class="row">
      <div class="row" style="position:relative;">
        <input [(ngModel)]="filterString" placeholder="Search..." name="search"/>
        <i class="fa fa-times" matTooltip="Clear database search" (click)="filterString='';updateSearchFilter()"></i>
      </div>
      <button type="submit" mat-button class="bordered-button search-button" [disabled]="!filterString">
        <i class="fa fa-search"></i>
      </button>
    </form>
  </div>
  <!--TODO style the paginator to match the site-->
  <mat-paginator showFirstLastButtons></mat-paginator>
</div>

<div class="table-container printout ">
  <table [dataSource]="dataSource" mat-table matSort (matSortChange)="updateSort($event)"
    matSortDirection="desc" class="table-striped simple-table">

    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column">
        @if (column==='component_type_name') {
          <th *matHeaderCellDef mat-sort-header class="freeze-pane" mat-header-cell>
            {{columnDict[column]}}
          </th>
        }
        @if (column!=='component_type_name') {
          <th *matHeaderCellDef class="freeze-pane" mat-header-cell>
            {{columnDict[column]}}
          </th>
        }
        @if (column==='printout_name') {
          <ng-container *matCellDef="let element">
            <td mat-cell class="left">
              <div class="row center">
                <i class="edit-inline hide-xs" (click)="addEditMapper(element)"></i>
                @if (!element.attributes?.printout_id) {
                  <div>{{element.attributes.printout_name}}</div>
                }
                @if (element.attributes?.printout_id) {
                  <div
                    >{{element.attributes.printout_id | upperfirst | removeUnderscore}}
                  </div>
                }
              </div>
            </td>
          </ng-container>
        }
        @if (column==='component_type_name') {
          <td *matCellDef="let element" class="left" mat-cell>
            {{element.attributes.component_type_name}}
          </td>
        }
        @if (column==='conditions') {
          <td *matCellDef="let element" mat-cell class="left" [ngClass]="{'condition-padding': printoutComponentTypeFlatten[element.id]}">
            @for (item of printoutComponentTypeFlatten[element.id]|keyvalue; track item.key) {
              <div title="the title">{{item.key}} = {{item.value}}</div>
            }
          </td>
        }
        @if (column==='delete') {
          <td *matCellDef="let element" mat-cell class="center">
            <span class="fa fa-trash" (click)="deleteMapper(element)"></span>
          </td>
        }
      </ng-container>
    }

    <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
    <tr *matRowDef="let row; columns: columns;" mat-row></tr>

  </table>
</div>
